module.exports = __webpack_public_path__ + "img/help3-1-2.3cb82155.png";